import { useMemo } from "react"
import { formatNumber } from "services/Utils"

export default function PercentualComAlerta({ valor }) {

  const background = useMemo(() => {
    if (valor < 80) return 'var(--alerta-success-bg, #ddf3dd)'
    if (valor < 90) return 'var(--alerta-warning-bg, #fffac3)'
    return 'var(--alerta-danger-bg, #ffc3c3)'
  }, [valor])

  const color = useMemo(() => {
    if (valor < 80) return 'var(--alerta-success-color, inherit)'
    if (valor < 90) return 'var(--alerta-warning-color, inherit)'
    return 'var(--alerta-danger-color, inherit)'
  }, [valor])

  return (
    <span className="inline-block p-2 rounded" style={{
      background,
      color
    }}>
      {formatNumber(valor)}%
    </span>
  )
}